import React from 'react';

const TermsOfService = () => (
  <p className="u-mt">
    By booking an appointment you agree to the{' '}
    <a target="_blank" rel="noreferrer noopener" href="https://getsquire.com/terms-of-service">terms of service</a> and the{' '}
    <a target="_blank" rel="noreferrer noopener" href="https://getsquire.com/privacy-policy">privacy policy</a>.
  </p>
);

export default TermsOfService;



// WEBPACK FOOTER //
// ./src/app/reservation/components/TermsOfService.jsx